import { render, staticRenderFns } from "./GameManagement.vue?vue&type=template&id=60a4748d&scoped=true"
import script from "./GameManagement.vue?vue&type=script&lang=js"
export * from "./GameManagement.vue?vue&type=script&lang=js"
import style0 from "./GameManagement.vue?vue&type=style&index=0&id=60a4748d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4748d",
  null
  
)

export default component.exports